import {
  Alert,
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';

import axiosInstance from '@/services/axiosConfig';

export const MedicalRecordsAutomation = () => {
  const [batchSize, setBatchSize] = useState(5);
  const [firmId, setFirmId] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  const handleStart = async () => {
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      const response = await axiosInstance.post(
        '/api/automation/medical-records/start/',
        {
          batch_size: Number(batchSize),
          firm_id: firmId || null,
        },
      );
      setResult(response.data);
    } catch (err: any) {
      setError(err.message || 'Failed to start automation');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box p={4}>
      <Typography variant="h5" gutterBottom>
        Medical Records Task Automation
      </Typography>
      <Typography variant="body2" color="textSecondary" paragraph>
        This tool will fetch &quot;Medical Records&quot; tasks, use AI to
        extract search keywords, search Front, analyze conversations, and create
        Rainmaker suggestions if records are found.
      </Typography>

      <Box display="flex" flexDirection="column" gap={2} maxWidth={400}>
        <TextField
          label="Batch Size"
          type="number"
          value={batchSize}
          onChange={(e) => setBatchSize(Number(e.target.value))}
          fullWidth
          helperText="Number of tasks to process concurrently in each batch."
        />
        <TextField
          label="Firm ID (Optional)"
          value={firmId}
          onChange={(e) => setFirmId(e.target.value)}
          fullWidth
          helperText="Leave empty for all firms"
        />

        <Button
          variant="contained"
          color="primary"
          onClick={handleStart}
          disabled={loading}
        >
          {loading ? (
            <CircularProgress size={24} />
          ) : (
            'Start Automation Workflow'
          )}
        </Button>
      </Box>

      {error && (
        <Box mt={2}>
          <Alert severity="error">{error}</Alert>
        </Box>
      )}

      {result && (
        <Box mt={2}>
          <Alert severity="success">
            Workflow Started!
            <pre style={{ marginTop: 10 }}>
              {JSON.stringify(result, null, 2)}
            </pre>
          </Alert>
        </Box>
      )}
    </Box>
  );
};
